<template>
  <div>
    <section>
      <template>
        <v-container>
          <v-row>
            <v-col
              cols="12"
              :sm="$containerBreakpoint.smAndUp ? '12' : '12'"
              :md="$containerBreakpoint.mdAndUp ? '5' : '12'"
            >
              <v-skeleton-loader
                v-if="dataIsLoading"
                elevation="2"
                type="card, list-item-avatar-three-line, list-item-avatar-three-line"
              ></v-skeleton-loader>
              <v-card v-else class="pt-4">
                <v-card-title class="justify-center flex-column">
                  <v-avatar
                    size="160"
                    :color="
                      $vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-3'
                    "
                    rounded
                    class="mb-2"
                  >
                    <!-- TODO: Correct photoUrl -> resolution  -->
                    <v-img
                      v-if="personnelRecord.photoUrl"
                      contain
                      :src="personnelRecord.photoUrl"
                    ></v-img>
                    <v-icon v-else size="82">mdi-account-circle</v-icon>
                  </v-avatar>

                  <span
                    >{{ personnelRecord.title }}
                    {{ personnelRecord.firstName }}
                    {{ personnelRecord.lastName }}</span
                  >

                  <personnel-record-status-chip
                    :status="personnelRecord.status"
                    class="mt-2"
                  >
                  </personnel-record-status-chip>

                  <!-- <span class="body-2 text--secondary">{{
                    personnelRecord.dutyPosition.title
                  }}</span> -->
                </v-card-title>

                <!-- <v-card-text class="justify-center mt-6">
                  <v-card outlined class="mb-4">
                    <v-card-text>
                      <div class="d-flex align-center me-8">
                        <v-avatar color="red lighten-5" rounded class="me-4">
                          <v-icon size="22" color="red"> mdi-circle </v-icon>
                        </v-avatar>

                        <div>
                          <h3 class="text-xl font-weight-medium mb-n1">
                            {{ getAge(personnelRecord.birthdate) }}
                          </h3>
                          <span>Alter</span>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card outlined class="mb-4">
                    <v-card-text>
                      <div class="d-flex align-center me-8">
                        <div class="d-flex align-center me-4">
                          <v-avatar color="red lighten-5" rounded class="me-4">
                            <v-icon size="22" color="red">
                              mdi-timeline-clock
                            </v-icon>
                          </v-avatar>

                          <div>
                            <h3 class="text-xl font-weight-medium mb-n1">
                              {{ kFormatter(1201) }}
                            </h3>
                            <span>Dienstalter</span>
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-card-text> -->
              </v-card>
            </v-col>
            <v-col
              cols="12"
              :sm="$containerBreakpoint.smAndUp ? '12' : '12'"
              :md="$containerBreakpoint.mdAndUp ? '7' : '12'"
            >
              <v-skeleton-loader
                v-if="dataIsLoading"
                elevation="2"
                type="table-heading, table-tbody"
              ></v-skeleton-loader>
              <v-card v-else>
                <v-card-title class="body-2 v-card__subtitle"
                  ><v-icon left small class="mr-2"
                    >mdi-card-account-details</v-icon
                  >Allgemein</v-card-title
                >

                <v-divider></v-divider>
                <personnel-record-general-table
                  :user="personnelRecord"
                ></personnel-record-general-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <section v-if="checkIfSupport">
      <support-tools :sources="code"></support-tools>
    </section>
  </div>
</template>

<script>
import SupportTools from "@/components/_system/helpers/SupportTools.vue";
import PersonnelRecordStatusChip from "@/components/member-management/personnel-records/PersonnelRecordStatusChip.vue";
import PersonnelRecordGeneralTable from "@/components/member-management/personnel-records/PersonnelRecordGeneralTable.vue";
import containerBreakpoints from "@/mixins/containerBreakpoints.js";

export default {
  name: "member-management-personnel-records-details-general",
  mixins: [containerBreakpoints],
  components: {
    PersonnelRecordStatusChip,
    PersonnelRecordGeneralTable,
    SupportTools,
  },
  props: {
    personnelRecord: Object,
    propContainerWidth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dataIsLoading: false,
    };
  },
  computed: {
    checkIfSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
    code() {
      return [{ title: "personnelRecord", data: this.personnelRecord }];
    },
  },
  created() {
    this.initialize();
  },
  mounted() {
    // Only initialize container breakpoints if not in split pane context
    // (propContainerWidth watcher handles split pane case)
    if (!(this.propContainerWidth > 0)) {
      this.initContainerBreakpoints(this.$el);
    }
  },
  watch: {
    $route: "initialize",
    // Watch prop changes from parent component
    propContainerWidth: {
      immediate: true,
      handler(newWidth) {
        if (newWidth > 0) {
          // Only update if the breakpoint would change (to prevent unnecessary re-renders)
          const newBreakpoint = this._getBreakpointForWidth(newWidth);
          const currentBreakpoint = this._getBreakpointForWidth(
            this.containerWidth || 0
          );
          if (
            newBreakpoint !== currentBreakpoint ||
            this.containerWidth === 0
          ) {
            this.containerWidth = newWidth;
          }
        }
      },
    },
  },
  methods: {
    initialize() {},
    kFormatter(num, fraction = 2) {
      return num > 999 ? `${(num / 1000).toFixed(fraction)}k` : num;
    },
  },
};
</script>
